export const headerTypes = [
  { value: "NONE", label: "No Header" },
  { value: "TEXT", label: "Text Header" },
  { value: "IMAGE", label: "Image Header" },
  { value: "VIDEO", label: "Video Header" },
  { value: "DOCUMENT", label: "Document Header" },
];

export const copyCodeTexts = {
  en: "Copy offer code",
  es: "Copiar código de oferta",
  fr: "Copier le code de l'offre",
  en_US: "Copy offer code",
  pt_BR: "Copiar código da oferta",
  hi: "ऑफ़र कोड कॉपी करें",
  ar: "نسخ رمز العرض",
};